import { configureStore } from "@reduxjs/toolkit";
  import productReducer from "../features/products/productSlice";
  import clientReducer from "../features/clients/clientSlice";
import contactReducer from '../features/contact/contactSlice';
import brandReducer from "../features/brand/brandSlice";
import brandModelReducer from "../features/brandModel/brandModelSlice";
import uploadReducer from "../features/upload/uploadSlice";
import bookingReducer from "../features/booking/bookingSlice";
import loanEnqReducer from "../features/loanEnq/loanEnqSlice"
import blogReducer from "../features/blogs/blogSlice";


export const store = configureStore({
  reducer: {
    loanEnquiry:loanEnqReducer,
    product: productReducer,
    client: clientReducer,
    brand: brandReducer,
    brandModel: brandModelReducer,
    contact:contactReducer,
    upload: uploadReducer,
    booking:bookingReducer,
     blog: blogReducer,
    
  },
});
